import { usePrivateWorkspaceAgentSkillsCatalog } from '~/components/v2/components/workspace/workspace-agent-panel/PrivateWorkspaceAgentSkillsCatalogProvider';
import { usePrivateSkill } from '~/hooks/queries/skills/usePrivateSkill';

export type WorkspaceAgentSkillMonikerLabelState =
  | { status: 'pending' }
  | {
      description: string;
      name: string;
      slashCommand: string;
      status: 'resolved';
    }
  | { status: 'unavailable' };

export type UsePrivateWorkspaceAgentSkillMonikerLabelParams = {
  enabled: boolean;
  skillId: string;
};

export const usePrivateWorkspaceAgentSkillMonikerLabel = ({
  enabled,
  skillId,
}: UsePrivateWorkspaceAgentSkillMonikerLabelParams): { labelState: WorkspaceAgentSkillMonikerLabelState } => {
  const { getSkillById, isSkillsListLoading, workspaceId } = usePrivateWorkspaceAgentSkillsCatalog();
  const cached = getSkillById(skillId);

  const shouldFetch = enabled && !isSkillsListLoading && !cached && !!workspaceId && !!skillId;

  const { data, isError, isPending } = usePrivateSkill({ skillId, workspaceId }, { enabled: shouldFetch });

  if (enabled && isSkillsListLoading && !cached) {
    return { labelState: { status: 'pending' } };
  }

  if (cached) {
    return {
      labelState: {
        description: cached.description,
        name: cached.name,
        slashCommand: cached.slashCommand,
        status: 'resolved',
      },
    };
  }

  if (!enabled) {
    return { labelState: { status: 'pending' } };
  }

  if (data) {
    return {
      labelState: {
        description: data.description,
        name: data.name,
        slashCommand: data.slashCommand,
        status: 'resolved',
      },
    };
  }

  if (isError) {
    return { labelState: { status: 'unavailable' } };
  }

  if (shouldFetch && isPending) {
    return { labelState: { status: 'pending' } };
  }

  return { labelState: { status: 'unavailable' } };
};
